// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.atc {
  --present: #16a34a;
  --absent: #dc2626;
  --late: #d97706;
  --leave: #7c3aed;
  --holiday: #64748b;

  --primary: #92BCF2;
  --primary-dark: #92BCF2;
  --primary-light: #eef0fd;

  --bg: #f4f6fb;
  --surface: #ffffff;
  --border: #e4e7f0;

  --text-heading: #1e2358;
  --text-body: #45495c;
  --text-muted: #8a8fa3;

  /* Adjust these two to match your actual fixed header height and
     left-nav width from DevTools. */
  --atc-header-h: 64px;
  --atc-sidebar-w: 240px;

  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  color: var(--text-body);
  background: var(--bg);

  /* Self-contained fullscreen fix: position fixed relative to viewport,
     independent of any parent wrapper's height/overflow settings. */
  position: fixed !important;
  top: var(--atc-header-h) !important;
  left: var(--atc-sidebar-w) !important;
  right: 0 !important;
  bottom: 0 !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 10;
}

.atc *,
.atc *::before,
.atc *::after {
  box-sizing: border-box;
}

.atc button {
  font-family: inherit;
  cursor: pointer;
}

/* ---------- Top bar ---------- */

.atc-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 28px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  flex: 0 0 auto;
}

.atc-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.atc-brand-mark {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 18px;
  flex-shrink: 0;
}

.atc-brand h1 {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 19px;
  font-weight: 700;
  color: var(--text-heading);
  letter-spacing: -0.01em;
}

.atc-brand-sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--text-muted);
}

.atc-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.15s ease, transform 0.1s ease;
}

.atc-btn:active {
  transform: translateY(1px);
}

.atc-btn-primary {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 6px 16px -6px rgba(79, 70, 229, 0.55);
}

.atc-btn-primary:hover {
  background: var(--primary-dark);
}

.atc-plus {
  font-size: 16px;
  line-height: 1;
}

.atc-btn-ghost {
  background: var(--surface);
  color: var(--text-heading);
  border: 1px solid var(--border);
}

.atc-btn-ghost:hover {
  background: var(--primary-light);
  border-color: var(--primary);
}

.atc-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
}

/* ---------- Body layout ---------- */

.atc-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 16px 20px;
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.atc-sidebar {
  width: 260px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: visible;
  padding-right: 0;
}

.atc-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 14px;
  flex-shrink: 0;
}

.atc-card h2 {
  margin: 0 0 10px;
  font-family: "Poppins", sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-heading);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* Mini calendar */

.atc-mini-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  color: var(--text-heading);
  font-size: 14px;
  margin-bottom: 10px;
}

.atc-mini-nav {
  display: flex;
  gap: 4px;
}

.atc-mini-nav button {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-heading);
  font-size: 14px;
  line-height: 1;
}

.atc-mini-nav button:hover {
  background: var(--primary-light);
  border-color: var(--primary);
}

.atc-mini-dow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 11px;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.atc-mini-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.atc-mini-day {
  position: relative;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-size: 12.5px;
  color: var(--text-body);
  display: flex;
  align-items: center;
  justify-content: center;
}

.atc-mini-day:hover {
  background: var(--primary-light);
}

.atc-mini-day.is-outside {
  color: #c9cce0;
}

.atc-mini-day.is-today {
  font-weight: 700;
  color: var(--primary);
}

.atc-mini-day.is-selected {
  background: var(--primary);
  color: #fff;
}

.atc-mini-dot {
  position: absolute;
  bottom: 3px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

/* Legend */

.atc-legend ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  color: var(--text-body);
}

.atc-legend li {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Stats */

.atc-stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.atc-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 9px 10px;
  background: var(--bg);
  border-radius: 10px;
}

.atc-stat-num {
  font-family: "Poppins", sans-serif;
  font-size: 19px;
  font-weight: 700;
}

.atc-stat-label {
  font-size: 11.5px;
  color: var(--text-muted);
}

/* ---------- Main calendar ---------- */

.atc-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
}

.atc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  flex: 0 0 auto;
  flex-wrap: wrap;
}

.atc-toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.atc-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-heading);
  font-size: 16px;
  flex-shrink: 0;
}

.atc-icon-btn:hover {
  background: var(--primary-light);
  border-color: var(--primary);
}

.atc-toolbar-title {
  margin: 0 0 0 6px;
  font-family: "Poppins", sans-serif;
  font-size: 16.5px;
  font-weight: 700;
  color: var(--text-heading);
}

.atc-view-switch {
  display: flex;
  background: var(--bg);
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}

.atc-view-btn {
  border: none;
  background: transparent;
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-body);
}

.atc-view-btn.is-active {
  background: var(--primary);
  color: #fff;
}

.atc-view-area {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Month grid */

.atc-grid-head {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  flex: 0 0 auto;
}

.atc-grid-head div {
  padding: 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
}

.atc-month-grid {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, minmax(0, 1fr));
  overflow: hidden;
}

.atc-cell {
  position: relative;
  min-height: 0;
  min-width: 0;
  border: none;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  background: var(--surface);
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  text-align: left;
  overflow: hidden;
}

.atc-month-grid .atc-cell:nth-child(7n) {
  border-right: none;
}

.atc-cell:hover {
  background: var(--primary-light);
}

.atc-cell-num {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-heading);
}

.atc-cell.is-outside {
  background: #fafbfd;
}

.atc-cell.is-outside .atc-cell-num {
  color: #c9cce0;
}

.atc-cell.is-weekend {
  background: #fafbfd;
}

.atc-cell.is-today .atc-cell-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary);
  color: #fff;
}

.atc-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10.5px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.atc-chip-lg {
  font-size: 14px;
  padding: 8px 16px;
}

.atc-weekend-label {
  font-size: 10px;
  color: var(--text-muted);
}

.atc-weekend-label.atc-empty {
  color: #c9cce0;
}

/* Week view */

.atc-week-grid {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  overflow: hidden;
}

.atc-week-cell {
  border: none;
  border-right: 1px solid var(--border);
  background: var(--surface);
  padding: 18px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.atc-week-grid .atc-week-cell:last-child {
  border-right: none;
}

.atc-week-cell:hover {
  background: var(--primary-light);
}

.atc-week-cell.is-weekend {
  background: #fafbfd;
}

.atc-week-dow {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 600;
}

.atc-week-num {
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-heading);
}

.atc-week-cell.is-today .atc-week-num {
  color: var(--primary);
}

/* Day view */

.atc-day-panel {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.atc-day-hero {
  display: flex;
  align-items: center;
  gap: 16px;
}

.atc-day-date {
  font-family: "Poppins", sans-serif;
  font-size: 46px;
  font-weight: 700;
  color: var(--primary);
  line-height: 1;
}

.atc-day-dow {
  margin: 0;
  font-weight: 600;
  color: var(--text-heading);
  text-align: left;
}

.atc-day-month {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--text-muted);
  text-align: left;
}

.atc-day-time {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-heading);
}

.atc-day-notes {
  margin: 0;
  max-width: 420px;
  font-size: 13.5px;
  color: var(--text-body);
  background: var(--bg);
  padding: 10px 14px;
  border-radius: 10px;
}

/* ---------- Modal ---------- */

.atc-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(20, 24, 55, 0.45);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 200;
}

.atc-modal {
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--surface);
  border-radius: 16px;
  box-shadow: 0 30px 60px -20px rgba(20, 24, 55, 0.45);
  animation: atc-modal-in 0.16s ease;
}

@keyframes atc-modal-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.atc-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 12px;
  border-bottom: 1px solid var(--border);
}

.atc-modal-head h3 {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 15.5px;
  font-weight: 700;
  color: var(--text-heading);
}

.atc-modal-head p {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--text-muted);
}

.atc-modal-form {
  padding: 18px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.atc-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-heading);
}

.atc-field input[type="time"],
.atc-field textarea {
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-body);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 9px 11px;
  background: var(--bg);
  resize: vertical;
}

.atc-field input[type="time"]:focus,
.atc-field textarea:focus {
  outline: 2px solid var(--primary);
  outline-offset: 1px;
  background: var(--surface);
}

.atc-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.atc-status-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.atc-status-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-body);
}

.atc-status-option:hover {
  border-color: var(--primary);
}

.atc-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

/* ---------- Responsive ---------- */

@media (max-width: 1024px) {
  .atc {
    --atc-sidebar-w: 0px;
  }
}

@media (max-width: 860px) {
  .atc-body {
    flex-direction: column;
    overflow-y: auto;
  }

  .atc-sidebar {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .atc-mini {
    flex: 1 1 280px;
  }

  .atc-legend,
  .atc-stats {
    flex: 1 1 200px;
  }

  .atc-main {
    min-height: 480px;
  }
}

@media (max-width: 640px) {
  .atc {
    top: var(--atc-header-h) !important;
    left: 0 !important;
    height: auto !important;
    min-height: calc(100dvh - var(--atc-header-h)) !important;
    overflow-y: auto !important;
    position: fixed !important;
  }

  .atc-topbar {
    padding: 12px 14px;
  }

  .atc-brand h1 {
    font-size: 16.5px;
  }

  .atc-body {
    padding: 12px;
    overflow: visible;
  }

  .atc-sidebar {
    flex-direction: column;
  }

  .atc-toolbar {
    padding: 12px 14px;
  }

  .atc-toolbar-title {
    font-size: 14.5px;
    width: 100%;
    order: 3;
    margin: 4px 0 0;
  }

  .atc-main {
    min-height: 0;
  }

  .atc-grid-head {
    display: none;
  }

  .atc-month-grid {
    display: flex;
    flex-direction: column;
    overflow: visible;
  }

  .atc-cell {
    min-height: unset;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    border-right: none;
    padding: 12px 14px;
  }

  .atc-cell.is-outside {
    display: none;
  }

  .atc-cell-num {
    width: 26px;
    flex-shrink: 0;
  }

  .atc-week-grid {
    grid-template-columns: repeat(2, 1fr);
    overflow: visible;
  }

  .atc-week-cell {
    border-bottom: 1px solid var(--border);
    min-height: 140px;
  }

  .atc-day-hero {
    flex-direction: column;
    gap: 6px;
  }

  .atc-day-dow,
  .atc-day-month {
    text-align: center;
  }

  .atc-field-row {
    grid-template-columns: 1fr;
  }
}

/* ---------- List modal ("view all" on +N more) ---------- */

.atc-modal-list-body {
  padding: 14px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 60vh;
  overflow-y: auto;
}

.atc-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  border: 1px solid var(--border);
  background: var(--bg);
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13.5px;
  color: var(--text-body);
  text-align: left;
}

.atc-list-row:hover {
  border-color: var(--primary);
  background: var(--primary-light);
}

.atc-list-name {
  font-weight: 600;
  color: var(--text-heading);
}

/* Clickable "+N more" trigger */

.atc-more-link {
  cursor: pointer;
  text-decoration: underline;
}

.atc-more-link:hover {
  color: var(--primary);
}

/* Locked (past-day, non-admin) cells */

.atc-cell.is-locked,
.atc-week-cell.is-locked {
  cursor: not-allowed;
  opacity: 0.72;
}

.atc-cell.is-locked:hover,
.atc-week-cell.is-locked:hover {
  background: var(--surface);
}`, "",{"version":3,"sources":["webpack://./src/Pages/hr_app/Attendance/attendanceCal.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;;EAExB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;;EAEjB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;;EAErB;oCACkC;EAClC,oBAAoB;EACpB,sBAAsB;;EAEtB,mEAAmE;EACnE,uBAAuB;EACvB,qBAAqB;;EAErB;oEACkE;EAClE,0BAA0B;EAC1B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wEAAwE;EACxE,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,sCAAsC;;AAEtC;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,wCAAwC;;AAExC;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,aAAa;;AAEb;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,kBAAkB;IAClB,uBAAuB;IACvB,yDAAyD;IACzD,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,6DAA6D;;AAE7D;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;;AAEvC;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Inter:wght@400;500;600;700&display=swap\");\n\n.atc {\n  --present: #16a34a;\n  --absent: #dc2626;\n  --late: #d97706;\n  --leave: #7c3aed;\n  --holiday: #64748b;\n\n  --primary: #92BCF2;\n  --primary-dark: #92BCF2;\n  --primary-light: #eef0fd;\n\n  --bg: #f4f6fb;\n  --surface: #ffffff;\n  --border: #e4e7f0;\n\n  --text-heading: #1e2358;\n  --text-body: #45495c;\n  --text-muted: #8a8fa3;\n\n  /* Adjust these two to match your actual fixed header height and\n     left-nav width from DevTools. */\n  --atc-header-h: 64px;\n  --atc-sidebar-w: 240px;\n\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n  color: var(--text-body);\n  background: var(--bg);\n\n  /* Self-contained fullscreen fix: position fixed relative to viewport,\n     independent of any parent wrapper's height/overflow settings. */\n  position: fixed !important;\n  top: var(--atc-header-h) !important;\n  left: var(--atc-sidebar-w) !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: auto !important;\n  height: auto !important;\n  margin: 0 !important;\n\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  z-index: 10;\n}\n\n.atc *,\n.atc *::before,\n.atc *::after {\n  box-sizing: border-box;\n}\n\n.atc button {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n/* ---------- Top bar ---------- */\n\n.atc-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 28px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  flex: 0 0 auto;\n}\n\n.atc-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.atc-brand-mark {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: #fff;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.atc-brand h1 {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 19px;\n  font-weight: 700;\n  color: var(--text-heading);\n  letter-spacing: -0.01em;\n}\n\n.atc-brand-sub {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.atc-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.atc-btn:active {\n  transform: translateY(1px);\n}\n\n.atc-btn-primary {\n  background: var(--primary);\n  color: #fff;\n  box-shadow: 0 6px 16px -6px rgba(79, 70, 229, 0.55);\n}\n\n.atc-btn-primary:hover {\n  background: var(--primary-dark);\n}\n\n.atc-plus {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.atc-btn-ghost {\n  background: var(--surface);\n  color: var(--text-heading);\n  border: 1px solid var(--border);\n}\n\n.atc-btn-ghost:hover {\n  background: var(--primary-light);\n  border-color: var(--primary);\n}\n\n.atc-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: inline-block;\n}\n\n/* ---------- Body layout ---------- */\n\n.atc-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n  padding: 16px 20px;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n\n.atc-sidebar {\n  width: 260px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  overflow: visible;\n  padding-right: 0;\n}\n\n.atc-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 14px;\n  flex-shrink: 0;\n}\n\n.atc-card h2 {\n  margin: 0 0 10px;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-heading);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* Mini calendar */\n\n.atc-mini-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  color: var(--text-heading);\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.atc-mini-nav {\n  display: flex;\n  gap: 4px;\n}\n\n.atc-mini-nav button {\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-heading);\n  font-size: 14px;\n  line-height: 1;\n}\n\n.atc-mini-nav button:hover {\n  background: var(--primary-light);\n  border-color: var(--primary);\n}\n\n.atc-mini-dow {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.atc-mini-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.atc-mini-day {\n  position: relative;\n  aspect-ratio: 1;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  font-size: 12.5px;\n  color: var(--text-body);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.atc-mini-day:hover {\n  background: var(--primary-light);\n}\n\n.atc-mini-day.is-outside {\n  color: #c9cce0;\n}\n\n.atc-mini-day.is-today {\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.atc-mini-day.is-selected {\n  background: var(--primary);\n  color: #fff;\n}\n\n.atc-mini-dot {\n  position: absolute;\n  bottom: 3px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n}\n\n/* Legend */\n\n.atc-legend ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-body);\n}\n\n.atc-legend li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Stats */\n\n.atc-stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.atc-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 9px 10px;\n  background: var(--bg);\n  border-radius: 10px;\n}\n\n.atc-stat-num {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.atc-stat-label {\n  font-size: 11.5px;\n  color: var(--text-muted);\n}\n\n/* ---------- Main calendar ---------- */\n\n.atc-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.atc-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n}\n\n.atc-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.atc-icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-heading);\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.atc-icon-btn:hover {\n  background: var(--primary-light);\n  border-color: var(--primary);\n}\n\n.atc-toolbar-title {\n  margin: 0 0 0 6px;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16.5px;\n  font-weight: 700;\n  color: var(--text-heading);\n}\n\n.atc-view-switch {\n  display: flex;\n  background: var(--bg);\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n}\n\n.atc-view-btn {\n  border: none;\n  background: transparent;\n  padding: 7px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-body);\n}\n\n.atc-view-btn.is-active {\n  background: var(--primary);\n  color: #fff;\n}\n\n.atc-view-area {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Month grid */\n\n.atc-grid-head {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n  flex: 0 0 auto;\n}\n\n.atc-grid-head div {\n  padding: 8px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.atc-month-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-template-rows: repeat(6, minmax(0, 1fr));\n  overflow: hidden;\n}\n\n.atc-cell {\n  position: relative;\n  min-height: 0;\n  min-width: 0;\n  border: none;\n  border-right: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  background: var(--surface);\n  padding: 6px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  text-align: left;\n  overflow: hidden;\n}\n\n.atc-month-grid .atc-cell:nth-child(7n) {\n  border-right: none;\n}\n\n.atc-cell:hover {\n  background: var(--primary-light);\n}\n\n.atc-cell-num {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n.atc-cell.is-outside {\n  background: #fafbfd;\n}\n\n.atc-cell.is-outside .atc-cell-num {\n  color: #c9cce0;\n}\n\n.atc-cell.is-weekend {\n  background: #fafbfd;\n}\n\n.atc-cell.is-today .atc-cell-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: #fff;\n}\n\n.atc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.atc-chip-lg {\n  font-size: 14px;\n  padding: 8px 16px;\n}\n\n.atc-weekend-label {\n  font-size: 10px;\n  color: var(--text-muted);\n}\n\n.atc-weekend-label.atc-empty {\n  color: #c9cce0;\n}\n\n/* Week view */\n\n.atc-week-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  overflow: hidden;\n}\n\n.atc-week-cell {\n  border: none;\n  border-right: 1px solid var(--border);\n  background: var(--surface);\n  padding: 18px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.atc-week-grid .atc-week-cell:last-child {\n  border-right: none;\n}\n\n.atc-week-cell:hover {\n  background: var(--primary-light);\n}\n\n.atc-week-cell.is-weekend {\n  background: #fafbfd;\n}\n\n.atc-week-dow {\n  font-size: 12px;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.atc-week-num {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-heading);\n}\n\n.atc-week-cell.is-today .atc-week-num {\n  color: var(--primary);\n}\n\n/* Day view */\n\n.atc-day-panel {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n}\n\n.atc-day-hero {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.atc-day-date {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 46px;\n  font-weight: 700;\n  color: var(--primary);\n  line-height: 1;\n}\n\n.atc-day-dow {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-heading);\n  text-align: left;\n}\n\n.atc-day-month {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: left;\n}\n\n.atc-day-time {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n.atc-day-notes {\n  margin: 0;\n  max-width: 420px;\n  font-size: 13.5px;\n  color: var(--text-body);\n  background: var(--bg);\n  padding: 10px 14px;\n  border-radius: 10px;\n}\n\n/* ---------- Modal ---------- */\n\n.atc-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 24, 55, 0.45);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 200;\n}\n\n.atc-modal {\n  width: 100%;\n  max-width: 420px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background: var(--surface);\n  border-radius: 16px;\n  box-shadow: 0 30px 60px -20px rgba(20, 24, 55, 0.45);\n  animation: atc-modal-in 0.16s ease;\n}\n\n@keyframes atc-modal-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.atc-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 20px 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n.atc-modal-head h3 {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 15.5px;\n  font-weight: 700;\n  color: var(--text-heading);\n}\n\n.atc-modal-head p {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: var(--text-muted);\n}\n\n.atc-modal-form {\n  padding: 18px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.atc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n.atc-field input[type=\"time\"],\n.atc-field textarea {\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-body);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 9px 11px;\n  background: var(--bg);\n  resize: vertical;\n}\n\n.atc-field input[type=\"time\"]:focus,\n.atc-field textarea:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: 1px;\n  background: var(--surface);\n}\n\n.atc-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.atc-status-picker {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.atc-status-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-body);\n}\n\n.atc-status-option:hover {\n  border-color: var(--primary);\n}\n\n.atc-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1024px) {\n  .atc {\n    --atc-sidebar-w: 0px;\n  }\n}\n\n@media (max-width: 860px) {\n  .atc-body {\n    flex-direction: column;\n    overflow-y: auto;\n  }\n\n  .atc-sidebar {\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .atc-mini {\n    flex: 1 1 280px;\n  }\n\n  .atc-legend,\n  .atc-stats {\n    flex: 1 1 200px;\n  }\n\n  .atc-main {\n    min-height: 480px;\n  }\n}\n\n@media (max-width: 640px) {\n  .atc {\n    top: var(--atc-header-h) !important;\n    left: 0 !important;\n    height: auto !important;\n    min-height: calc(100dvh - var(--atc-header-h)) !important;\n    overflow-y: auto !important;\n    position: fixed !important;\n  }\n\n  .atc-topbar {\n    padding: 12px 14px;\n  }\n\n  .atc-brand h1 {\n    font-size: 16.5px;\n  }\n\n  .atc-body {\n    padding: 12px;\n    overflow: visible;\n  }\n\n  .atc-sidebar {\n    flex-direction: column;\n  }\n\n  .atc-toolbar {\n    padding: 12px 14px;\n  }\n\n  .atc-toolbar-title {\n    font-size: 14.5px;\n    width: 100%;\n    order: 3;\n    margin: 4px 0 0;\n  }\n\n  .atc-main {\n    min-height: 0;\n  }\n\n  .atc-grid-head {\n    display: none;\n  }\n\n  .atc-month-grid {\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n  }\n\n  .atc-cell {\n    min-height: unset;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    border-right: none;\n    padding: 12px 14px;\n  }\n\n  .atc-cell.is-outside {\n    display: none;\n  }\n\n  .atc-cell-num {\n    width: 26px;\n    flex-shrink: 0;\n  }\n\n  .atc-week-grid {\n    grid-template-columns: repeat(2, 1fr);\n    overflow: visible;\n  }\n\n  .atc-week-cell {\n    border-bottom: 1px solid var(--border);\n    min-height: 140px;\n  }\n\n  .atc-day-hero {\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .atc-day-dow,\n  .atc-day-month {\n    text-align: center;\n  }\n\n  .atc-field-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- List modal (\"view all\" on +N more) ---------- */\n\n.atc-modal-list-body {\n  padding: 14px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.atc-list-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  border: 1px solid var(--border);\n  background: var(--bg);\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 13.5px;\n  color: var(--text-body);\n  text-align: left;\n}\n\n.atc-list-row:hover {\n  border-color: var(--primary);\n  background: var(--primary-light);\n}\n\n.atc-list-name {\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n/* Clickable \"+N more\" trigger */\n\n.atc-more-link {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.atc-more-link:hover {\n  color: var(--primary);\n}\n\n/* Locked (past-day, non-admin) cells */\n\n.atc-cell.is-locked,\n.atc-week-cell.is-locked {\n  cursor: not-allowed;\n  opacity: 0.72;\n}\n\n.atc-cell.is-locked:hover,\n.atc-week-cell.is-locked:hover {\n  background: var(--surface);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
